/*
 *==================================================
 * Licensed Materials - ADIACENT
 *
 * user roles (mroService.getRoles) held in redux state
 *
 *==================================================
 */
//Standard libraries
import { call, put } from "redux-saga/effects";
//Foundation libraries
import mroService from "../../../components/apis/transaction/mro.service";
//Redux
import { USER_ROLES_GET_SUCCESS_ACTION } from "../../actions/userRoles";

export function* getUserRoles(action: any) {
  const { storeId } = action.payload;
  try {
    const response = yield call(mroService.getRoles, storeId);
    if (response.data?.roles) {
      yield put(USER_ROLES_GET_SUCCESS_ACTION(response.data));
    }
  } catch (e) {
    console.log("Eccezione caricamento RUOLI UTENTE");
    console.log(e);
  }
}
